var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sideBar"},[_c('div',{staticClass:"side-item-block"},_vm._l((_vm.sidebarItem),function(sub){return _c('div',{class:_vm.defaultActive==sub.parentName?'whitefont-btn index':'orange-btn index',on:{"click":function($event){return _vm.handleMenuItem(sub)}}},[_c('span',[_vm._v(_vm._s(sub.title))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }